import {DRVBundGlobals, FeatureToggleProvider} from '@zs21/drv-bund-common-ilias-utils';
import React from 'react';

export const featureToggleConfig = {
    url: DRVBundGlobals.ILIAS_BASE_ADDRESS + '/Customizing/global/plugins/Services/UIComponent/UserInterfaceHook/LMSSync/index.php?target=feature-toggles',
    usedFeatureToggleKeys: [],
};

export const withFeatureToggleProvider = (children) => {
    return <FeatureToggleProvider
        url={featureToggleConfig.url}
        usedFeatureToggleKeys={featureToggleConfig.usedFeatureToggleKeys}
    >
        {children}
    </FeatureToggleProvider>;
};
